import { BarChartOutlined } from '@ant-design/icons'
import { Card, Space } from 'antd'
import Chart from 'react-apexcharts';

const StockMovement = ({ data, height = 350, loading }) => {
    const stockMovementOptions = {
        chart: {
            type: 'bar',
            height: 350,
            toolbar: { show: false },
            background: 'transparent'
        },
        plotOptions: {
            bar: {
                horizontal: false,
                columnWidth: '60%',
                borderRadius: 6,
                borderRadiusApplication: 'end',
                borderRadiusWhenStacked: 'last',
            }
        },
        dataLabels: { enabled: false },
        stroke: {
            show: true,
            width: 2,
            colors: ['transparent']
        },
        xaxis: {
            categories: data?.categories || [],
            axisBorder: { show: false },
            axisTicks: { show: false }
        },
        yaxis: {
            title: { text: 'Quantity' }
        },
        fill: { opacity: 1 },
        tooltip: {
            y: {
                formatter: (val) => val + ' Qty'
            }
        },
        colors: ["#4099ff", "#2ed8b6", "#FFB64D"],
        legend: {
            position: 'top',
            horizontalAlign: 'left'
        },
        grid: {
            borderColor: '#f1f1f1',
            strokeDashArray: 4
        }
    };

    const stockMovementSeries = [
        { name: 'Stock In', data: data?.stockInData },
        { name: 'Stock Out', data: data?.stockOutData }
    ];

    return (
        <Card
            title={
                <Space>
                    <BarChartOutlined style={{ color: '#1e88e5' }} />
                    <span style={{ fontWeight: 600 }}>Stock Movement Activity</span>
                </Space>
            }
            styles={{
                header: { background: '#f5f5f5' },
                body: { padding: '24px' }
            }}
            style={{
                borderRadius: '12px',
                boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
                border: '1px solid #f0f0f0',
                height: '100%',
                minHeight: height
            }}
            loading={loading}
        >
            <Chart
                options={stockMovementOptions}
                series={stockMovementSeries}
                type="bar"
                height={height}
            />
        </Card>)
}

export default StockMovement